var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSettingsSection',{staticClass:"access",attrs:{"name":_vm.t('privacy', 'Who has access to your data?')}},[_c('AdminAccess',{staticClass:"access__section"}),_vm._v(" "),_c('ShareAccess',{staticClass:"access__section"}),_vm._v(" "),_c('Privacy',{staticClass:"access__section"}),_vm._v(" "),_c('Encryption',{staticClass:"access__section"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }